import React, { PropTypes } from 'react';
import DateInput from 'components/DateInput';

const ReferralFormDatepicker = (props) => {
  const { input, label, isRequired, dateFormat, meta: { touched, error } }  = props;
  const hasError = touched && error;

  return (
    <div>
      <label htmlFor={`${input.name}`}>
        {label}
        {isRequired && <span className="required"> *</span>}
      </label>

      <DateInput
        input={input}
        format={dateFormat}
        className={hasError ? 'is-invalid-input' : ''}
      />
      {hasError && <span className="form-error is-visible">{error}</span>}
    </div>
  );
};

ReferralFormDatepicker.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  dateFormat: PropTypes.string,
  isRequired: PropTypes.bool,
  meta: PropTypes.object
};

export default ReferralFormDatepicker;




/** WEBPACK FOOTER **
 ** ./src/members/Main/Referral/ReferralForm/ReferralFormDatepicker/index.js
 **/